export const Constants = {
  MAX_FILE_SIZE_UPLOAD: 10 * 1024 * 1024 * 1024,
};
